<template>
  <div>
    <slot name="header" />
    <slot />
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({});
</script>
